import dayjs from 'dayjs';
import { valueOrDefault } from './RenderUtils';
export function SearchItemForText(text, item, columns) {
    var lowerCaseText = text.toLowerCase();
    if (columns) {
        for (var i = 0; i < columns.length; i++) {
            var field = columns[i].fieldName;
            if (field) {
                if (item[field] && valueOrDefault(item[field], '').toLowerCase().indexOf(lowerCaseText) > -1) {
                    return true;
                }
            }
        }
        return false;
    }
    else {
        for (var field in item) {
            if (item[field] && valueOrDefault(item[field], '').toLowerCase().indexOf(lowerCaseText) > -1) {
                return true;
            }
        }
        return false;
    }
}
export var SortByDate = function (a, b) {
    if (!a && !b) {
        return 0;
    }
    else if (!a) {
        return 1;
    }
    else if (!b) {
        return -1;
    }
    else {
        var dayjsA = dayjs(a.toDate());
        var dayjsB = dayjs(b.toDate());
        return dayjsA.diff(dayjsB);
    }
};
export function SortListItems(items, config) {
    var out = Array.from(items);
    var sortFunction = getSortFunctionForConfig(config);
    return out.sort(config.isSortedDescending ? function (a, b) { return sortFunction(b, a); } : sortFunction);
}
function getSortFunctionForConfig(config) {
    if (config.sort) {
        return config.sort;
    }
    switch (config.type) {
        case 'number':
        case 'currency':
            return function (a, b) { return Number(extractData(a, config)) - Number(extractData(b, config)); };
        case 'dayjs':
            return function (a, b) { return SortByDate(extractData(a, config), extractData(b, config)); };
        default:
            return function (a, b) {
                var aVal = valueOrDefault(extractData(a, config), '').trim().toLowerCase();
                var bVal = valueOrDefault(extractData(b, config), '').trim().toLowerCase();
                if (aVal < bVal) {
                    return -1;
                }
                else if (aVal > bVal) {
                    return 1;
                }
                else {
                    return 0;
                }
            };
    }
}
export function fetchCachedSortColumnKey(cacheSortKeys) {
    if (!cacheSortKeys) {
        return undefined;
    }
    var raw = sessionStorage.getItem(cacheSortKeys.cacheKey);
    if (!raw) {
        return undefined;
    }
    var cachedColumns = JSON.parse(raw);
    if (cacheSortKeys.sessionId in cachedColumns) {
        return cachedColumns[cacheSortKeys.sessionId];
    }
    return undefined;
}
export function writeCachedSortColumnKey(cacheSortKeys, columnKey, reverse) {
    if (!cacheSortKeys) {
        return;
    }
    var existing;
    var existingRaw = sessionStorage.getItem(cacheSortKeys.cacheKey);
    if (existingRaw) {
        existing = JSON.parse(existingRaw);
    }
    else {
        existing = {};
    }
    existing[cacheSortKeys.sessionId] = { key: columnKey, reverse: reverse };
    sessionStorage.setItem(cacheSortKeys.cacheKey, JSON.stringify(existing));
}
export function extractData(item, column) {
    if (column.getValue) {
        return column.getValue(item);
    }
    if (column.fieldName) {
        return item[column.fieldName];
    }
    return undefined;
}
//# sourceMappingURL=ListHelpers.js.map